<template>
    <div class="mobile-screen-manager">
        <slot></slot>
        <span id="mobileHelper" class="helper hide-on-desktop"></span>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    import _find from 'lodash/find'
    import _findIndex from 'lodash/findIndex'
    import _forEach from 'lodash/forEach'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

            _find(this.$children,o => { return o.$props.id == this.current}).show();

        },
        name: 'MobileScreenManager',
        props: {
            current: {
                type: String,
                required: true
            }
        },
        updated: function () {

        },
        watch: {
            current: {
                deep: false,
                handler(newVal, oldVal) {
                    let toShowIndex = _findIndex(this.$children,o => { return o.$props.id == newVal});
                    let toShow = _find(this.$children,o => { return o.$props.id == newVal});

                    _forEach(this.$children,(val,key) => {
                        if(key > toShowIndex){
                            val.hide(true);
                        }
                        else{
                            val.hide();
                        }

                    });

                    toShow.show();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ui/MobileScreenManager.vue